export class EditarLojaModel {
   constructor(
      public id: string = '',
      public documento: string = '',
      public razaoSocial: string = '',
   ) { }
}